import React, { useState, useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";

import { slide_bounce_variants, slide_bounce_down_variants } from "shared/components/animations";
import crossIcon from "assets/images/gah/cross.png";

const CardModal = ({
  card,
  onConfirmCard,
  toggleCardModal,
  isNewCard = false,
  isEvaluating = false,

}) => {
  const [counter, setCounter] = useState(3);
  const [crossSelect, setcrossSelect] = useState(false)
  let timer;
  useEffect(() => {
    if (isNewCard) {
      timer =
        counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
      counter === 0 && onConfirmCard();
    }
    return () => clearInterval(timer);
  }, [counter, isNewCard]);

  return (
    <div className="card-modal-container">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={crossSelect ? slide_bounce_down_variants : slide_bounce_variants}
        className="card-modal-inner"
      >
        <div className="top-div">
          <h2>
            {isNewCard
              ? "New Card"
              : isEvaluating
                ? "You Sure?"
                : "Final answer?"}
          </h2>
          {!isNewCard && (
            <img alt="" src={crossIcon} onClick={() => {
              toggleCardModal();
              setcrossSelect(true);
            }} />
          )}
        </div>

        {/* <div className="modal-card-container">
          <div className="title-div">
            <h2>{card.text}</h2>
          </div>

          <div className="gif-div" style={{}}>
            <img alt="" src={card.gif_url} />
          </div>
        </div> */}

        <div className="modal-card-wrapper">
          <div className="title-div">
            <h2>{card.text}</h2>
          </div>

          <div className="gif-div">
            <img alt="" src={card.gif_url} />
          </div>
        </div>

        <div
          onClick={() => onConfirmCard(card.id)}
          className={`modal-flip-div ${isNewCard ? "new-card" : ""}`}
        >
          <div className={`button-border-div ${isNewCard ? "new-card" : ""}`} />
          <h2>
            {isNewCard ? `SWEET (${counter})` : isEvaluating ? "YUP" : "YES"}
          </h2>
        </div>
      </motion.div>
    </div>
  );
};

export default CardModal;
